<template>
    <header class="w-full bg-gray-800 fixed top-0 z-50 flex items-center justify-center h-[70px] border-b">
        <div class="flex w-full justify-between items-center relative">
            <div @click="gotoho" class="lg:w-[250px] md:w-[78px] lg:pl-[40px] pl-[25px]">
                <img src="../assets/logo.png" alt="Logo" class="h-[60px]">
            </div>
            <div class="lg:w-[calc(100%-250px)] md:w-[calc(100%-78px)] px-[20px] flex justify-between items-center relative">
                <div v-if="route.path === '/logements'" class="w-full hidden lg:max-w-[700px] max-w-[400px] md:flex items-center justify-start ">
                    <div class="w-full lg:max-w-[600px] max-w-[400px] relative">
                        <label for="" class="text-sm font-bold text-gray-800 absolute right-[10px] top-[10px]">
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24"><!-- Icon from Google Material Icons by Material Design Authors - https://github.com/material-icons/material-icons/blob/master/LICENSE --><path fill="currentColor" d="M15.5 14h-.79l-.28-.27a6.5 6.5 0 0 0 1.48-5.34c-.47-2.78-2.79-5-5.59-5.34a6.505 6.505 0 0 0-7.27 7.27c.34 2.8 2.56 5.12 5.34 5.59a6.5 6.5 0 0 0 5.34-1.48l.27.28v.79l4.25 4.25c.41.41 1.08.41 1.49 0s.41-1.08 0-1.49zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5S14 7.01 14 9.5S11.99 14 9.5 14"/></svg>
                        </label>
                        <input type="text" class="w-full max-w-[600px] pr-[30px] p-[10px] outline-none shadow-4xl text-sm rounded-[5px] mr-[15px] bg-white" placeholder="Recherchez un bien, une ville, un quartier...">
                    </div>
                    <div class="p-[10px] md:flex hidden w-auto text-sm ml-[10px] cursor-pointer border bg-white items-center justify-center rounded-[5px]">
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24"><!-- Icon from Mage Icons by MageIcons - https://github.com/Mage-Icons/mage-icons/blob/main/License.txt --><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-miterlimit="10" stroke-width="1.5" d="M21.25 12H8.895m-4.361 0H2.75m18.5 6.607h-5.748m-4.361 0H2.75m18.5-13.214h-3.105m-4.361 0H2.75m13.214 2.18a2.18 2.18 0 1 0 0-4.36a2.18 2.18 0 0 0 0 4.36Zm-9.25 6.607a2.18 2.18 0 1 0 0-4.36a2.18 2.18 0 0 0 0 4.36Zm6.607 6.608a2.18 2.18 0 1 0 0-4.361a2.18 2.18 0 0 0 0 4.36Z"/></svg>
                    </div>
                </div>
                <div v-else>

                </div>
                <div class="flex items-center relative">
                    <div class="md:ml-[20px] hidden md:flex justify-center items-center">
                        <div class="md:flex hidden flex-col justify-center items-end">
                            <h2 class="text-sm text-white font-semibold">{{ authStore.currentUser?.nom }} {{ authStore.currentUser?.prenoms }}</h2>
                            <span class="text-gray-200 text-xs font-semibold">{{ authStore.currentUser?.phone || 'Non renseigné' }}</span>
                        </div>
                        <div class="md:w-[46px] w-[34px] bg-[#FFF] md:h-[46px] h-[34px] ml-[10px] rounded-[50%] flex items-center justify-center overflow-hidden">
                            
                        </div>
                    </div>
                    <div class="text-white ml-[10px] md:hidden flex" @click="sidebarStore.toggleSidebar()">
                        <svg v-if="sidebarStore.isOpen" xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 16 16"><!-- Icon from Gravity UI Icons by YANDEX LLC - https://github.com/gravity-ui/icons/blob/main/LICENSE --><path fill="currentColor" fill-rule="evenodd" d="M3.47 3.47a.75.75 0 0 1 1.06 0L8 6.94l3.47-3.47a.75.75 0 1 1 1.06 1.06L9.06 8l3.47 3.47a.75.75 0 1 1-1.06 1.06L8 9.06l-3.47 3.47a.75.75 0 0 1-1.06-1.06L6.94 8L3.47 4.53a.75.75 0 0 1 0-1.06" clip-rule="evenodd"/></svg>
                        <svg v-else xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 12 16"><!-- Icon from Octicons by GitHub - https://github.com/primer/octicons/blob/main/LICENSE --><path fill-rule="evenodd" d="M11.41 9H.59C0 9 0 8.59 0 8c0-.59 0-1 .59-1H11.4c.59 0 .59.41.59 1c0 .59 0 1-.59 1h.01zm0-4H.59C0 5 0 4.59 0 4c0-.59 0-1 .59-1H11.4c.59 0 .59.41.59 1c0 .59 0 1-.59 1h.01zM.59 11H11.4c.59 0 .59.41.59 1c0 .59 0 1-.59 1H.59C0 13 0 12.59 0 12c0-.59 0-1 .59-1z" fill="currentColor"/></svg>
                    </div>
                </div>
            </div>
        </div>
    </header>
</template>

<script setup>
import { ref } from 'vue'
import { useSidebarStore } from '@/store/sidebarStore'
import { useRoute, useRouter } from 'vue-router'
import { useAuthStore } from '@/store/auth';
import apiClient from '@/services/api';

const authStore = useAuthStore();
const route = useRoute()
const router = useRouter()
const gotoho = () => {
    if (route.path !== '/') {
        router.push('/')
    }
}

const sidebarStore = useSidebarStore()

const isOpen = ref(false)
</script>

<style>

</style>